import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { InlineSpinner } from "@/components/common/Loading";
import { Trash2 } from "lucide-react";

const LABELS = { "persons.assigned_recruiter_id": "assigned candidates", "recruiting_opportunities.assigned_recruiter_id": "opportunities",
  "tasks.assignee_id": "tasks", "appointments.assigned_recruiter_id": "meetings", "projects.owner_id": "projects" };

export function DeleteUserDialog({ userRow, onClose, onDeleted }) {
  const [prev, setPrev] = useState(null);
  const [err, setErr] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/users/${userRow.id}/delete-preview`).then((r) => setPrev(r.data)).catch((e) => setErr(apiError(e)));
  }, [userRow.id]);
  const del = async () => {
    setBusy(true);
    try { await api.delete(`/users/${userRow.id}`); toast.success(`${userRow.name} deleted`); onDeleted(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const ua = Object.entries(prev?.will_unassign || {});
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-md" data-testid="delete-user-dialog">
        <DialogHeader><DialogTitle className="text-rose-700 flex items-center gap-2"><Trash2 className="w-5 h-5" /> Delete User</DialogTitle></DialogHeader>
        {err ? <p className="text-sm text-rose-600" data-testid="delete-user-error">{err}</p> : !prev ? <InlineSpinner /> : (
          <div className="space-y-3 text-sm text-slate-600">
            <p>Permanently delete the login <strong>{userRow.name}</strong> ({userRow.email}) with its roles, invitations and sessions. Use Deactivate instead if they may return.</p>
            <p data-testid="delete-user-unassign">{ua.length ? <>Work assigned to them will become <b>Unassigned</b>: {ua.map(([k, n]) => `${n} ${LABELS[k] || k.split(".")[0].replace(/_/g, " ")}`).join(", ")}.</> : "Nothing is currently assigned to them."}</p>
            {userRow.linked_person && <p className="text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-2">The linked Person <strong>{userRow.linked_person.name}</strong> and all history are kept.</p>}
            <p className="text-xs text-slate-500">Type DELETE to confirm. This cannot be undone.</p>
            <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="DELETE" data-testid="delete-user-confirm-input" />
          </div>)}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="delete-user-cancel">Cancel</Button>
          <Button onClick={del} disabled={busy || !prev || text !== "DELETE"} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="delete-user-confirm">{busy ? <InlineSpinner /> : "Delete User"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
